import $ from 'jquery';

function UserImagesUploaderInit() {
  var blockSelector = '.user-image-block';
  var selector = '.user-image-add';
  $(document).on('click', selector, function () {
    $(blockSelector).toggle("slow");
  });
}

function UserImagesMonthsInit() {
  var selector = '.user-image-months';
  $(document).on('change', selector, function (e) {
    e.preventDefault();
    var option = $(this).find(':selected');
    var url = option.attr('data-url');
    window.location = url;
  });
}

function UserImagesVoterInit() {
  var selector = '.user-image-vote';
  $(document).on('click', selector, function () {
    var url = $(this).attr("data-url");
    var s = $(this).next('span');
    $.ajax({
      type: "POST",
      url: url,
      data: {},
      crossDomain: true,
      headers: {'X-Requested-With':'XMLHttpRequest'},
      success: function (ret) {
        if (ret.cnt !== null) {
          s.html(ret.cnt);
        }
        dialogBox('DVTK', ret.msg);
      }
    });
  });
}

function UserImagesRemoverInit() {
  var selector = '.user-image-remove';
  $(document).on('click', selector, function () {
    var c = confirm("Biztosan el akarod távolítani a feltöltött képet?");
    if (c) {
      var e = $(this);
      var url = e.attr("data-url");
      $.ajax({
        type: "POST",
        url: url,
        data: {},
        crossDomain: true,
        headers: {'X-Requested-With':'XMLHttpRequest'},
        success: function (ret) {
          if (ret.success) {
            e.remove();
          }
          dialogBox('DVTK', ret.msg);
        }
      });
    }
  });
}

$(document).ready(function () {
  console.log("frontend: userimage ready");

  UserImagesUploaderInit();
  UserImagesMonthsInit();
  UserImagesVoterInit();
  UserImagesRemoverInit();
});
